import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from 'shared/components/form/button';
import { CrossIcon } from 'shared/icons/icon';
import { State } from 'shared/interface';
import { createAction } from 'shared/util/utility';
import * as actionTypes from 'store/action-types';

import { getDisplayField } from 'shared/util/utility';
import { IAdvanceChartConfigType, IChartDetails, IChartSettingsType } from 'features/futuretable/interface/futureTable';
import ChartHoverTooltip from './chartHoverTooltip';
import DragHandle from './dragHandle';

interface Props {
	name: string;
	elementId: string;
	action: boolean;
	deleteData: (data: string, action: boolean) => void;
	navigateUrl?: string;
	section: string;
	advanceChartConfig?: IAdvanceChartConfigType;
	cardIndex?: number;
	updatedChartSettings?: IChartSettingsType[];
	navigateToPage?: () => void;
	chartDetails?: { [key: string]: IChartDetails };
	loading?: boolean;
}

const DashboardCardHeader: React.FC<Props> = (props) => {
	const {
		action,
		deleteData,
		elementId,
		name,
		navigateUrl,
		section,
		advanceChartConfig,
		cardIndex,
		updatedChartSettings,
		navigateToPage,
		loading,
		chartDetails
	} = props;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const [isShowPopup, setIsShowPopup] = useState<{ [key: string]: boolean }>({});
	const { chartLastObj } = useSelector((state: State) => state.chartConfigReducer);
	const chart = advanceChartConfig?.chartSettings[0];
	const isIframe = location.pathname.includes('iframe');

	const displayField =
		updatedChartSettings?.length === 1 && chartDetails
			? getDisplayField(
					chartDetails[`${chart?.symbol}-${chart?.boerse}-0`]?.field,
					chartDetails[`${chart?.symbol}-${chart?.boerse}-0`]?.originalField as string
			  )
			: '';

	return (
		<>
			<div className='card-header__wrapper border-bottom-grayscale d-flex justify-content-space-between full-width align-items-center'>
				<div className='header-info__wrapper d-flex align-items-center'>
					<DragHandle section={section} />
					<p
						onClick={() => {
							dispatch(createAction(actionTypes.UPDATE_CHART_CONFIG, false));
							dispatch(createAction(actionTypes.UPDATE_CHART_CONFIG_FROM_DASHBOARD, true));
							navigateToPage && navigateToPage();
							navigateUrl && navigate(navigateUrl);
						}}
						className={`card-header font--16px ml-10 no-margin cursor-pointer truncate--lines-1 font-weight--600 line-height--22px ${
							loading && 'disabled'
						}`}
						onMouseOver={() => {
							setIsShowPopup({ ...isShowPopup, [elementId]: true });
						}}
						onMouseOut={() => setIsShowPopup({ ...isShowPopup, [elementId]: false })}
					>
						{name || chart?.name} {displayField ? `- ${displayField}` : ''}
					</p>
				</div>
				{!isIframe && (
					<div className='cross-icon__wrapper d-flex align-items-center justify-content-center'>
						<Button className='no-border height--auto' onClick={() => deleteData(elementId, action)} disabled={loading}>
							<CrossIcon className='cross-icon' />
						</Button>
					</div>
				)}
			</div>
			{!isEmpty(updatedChartSettings) &&
				updatedChartSettings &&
				chartLastObj[`${chart?.symbol}-${chart?.boerse}`] &&
				isShowPopup[elementId] &&
				!isEmpty(chartDetails) &&
				!Object.values(chartDetails).every((item) => item?.disallowed === 1) && (
					<ChartHoverTooltip
						elementId={elementId}
						cardIndex={cardIndex as number}
						chartLastObj={chartLastObj[`${chart?.symbol}-${chart?.boerse}`]}
						updatedChartSettings={updatedChartSettings as IChartSettingsType[]}
						chartDetails={chartDetails}
					/>
				)}
		</>
	);
};

export default DashboardCardHeader;
